import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [RouterModule],
  template: `
    <div class="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <h1 class="text-6xl font-bold text-neutral-300 mb-2">404</h1>
      <h2 class="text-xl font-semibold text-neutral-700 mb-2">Page not found</h2>
      <p class="text-neutral-500 mb-6 max-w-md">The page you're looking for doesn't exist or has been moved.</p>
      <a routerLink="/" class="sz-btn-primary">Go to Dashboard</a>
    </div>
  `,
})
export class NotFoundComponent {}
